import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import DocPage from '@/pages/common/Dialog/DialogDocumentEdit/DocPage';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

import { Root } from '@/pages/common/Dialog/DialogDocumentEdit/DocumentPages/StyledComponents';

const DocumentPages = ({ items, children, idKey, dataElement }) => (
  <Root data-element={dataElement} dir="ltr">
    {items.map((item, index) => {
      const key = isFunction(idKey) ? idKey(item) : get(item, idKey, index);
      return (
        <DocPage key={`item-${key}`} index={index} item={item} itemIndex={index}>
          {children}
        </DocPage>
      );
    })}
  </Root>
);

export default SortableContainer(DocumentPages);
